import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
  }
  
  //Mobile devices
  @media only screen and (max-width: 480px) {
     
    #app {
      padding: 24px 16px;
    }
  }

  //Tablets devices
  @media only screen and (min-width: 481px) and (max-width: 768px) {
    #app {
      padding: 32px 16px 32px 40px;
    }
  }

    @media only screen and (min-width: 769px) and (max-width: 1250px)  {
    #app {
      padding: 32px 16px 32px 40px ;
    }
  }

  //Desktop devices
  @media only screen and (min-width: 1255px) {
    #app {
      padding: 64px 0px 56px 0px;
      margin: 0 auto;
      max-width: 1278px;
      width: 100%;
    }

    #app {
    font-family: "BrandFont-Display", arial, helvetica;
  }

  .MuiPaper-root {
    background: linear-gradient(180deg, rgba(243, 243, 245, 0.8) 0%, rgba(242, 242, 242, 0.8) 100%);
    border-radius: 0px 0px 12px 12px !important;
  }
  }
`;


